interface Task {
    type: string
}

export const hasTaskOfType = (record: { tasks?: Task[] }, taskType: string): boolean => {
    return record.tasks?.some((task: Task) => task.type === taskType) ?? false
}